<div class="grid" *ngIf="!(isMobile$ | ngrxPush); else mobileTemplate">
    <img ngSrc="/assets/images/where-you-can-fly/drone-banner.png" alt="" width="566" height="212" />
    <div>
        <h2>{{ "dtmMainPageLib.subpage.whereYouCanFly.banner.title" | transloco }}</h2>
        <button routerLink="/where-you-can-fly" type="button" class="button-primary">
            {{ "dtmMainPageLib.subpage.whereYouCanFly.banner.buttonLabel" | transloco }}
        </button>
    </div>
</div>

<ng-template #mobileTemplate>
    <div class="grid mobile">
        <div>
            <h2>{{ "dtmMainPageLib.subpage.whereYouCanFly.banner.title" | transloco }}</h2>
            <button routerLink="/where-you-can-fly" type="button" class="button-primary">
                {{ "dtmMainPageLib.subpage.whereYouCanFly.banner.buttonLabel" | transloco }}
            </button>
        </div>
        <img ngSrc="/assets/images/where-you-can-fly/drone-banner-mobile.png" alt="" width="414" height="279" />
    </div>
</ng-template>
